import React, { useState } from 'react';
import { addCrmLeadContact } from '../config/api';

const CrmAddContactDialog = ({ leadId, onClose, onSaved }) => {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    designation: '',
    isPrimary: false,
    doNotCall: false,
    noWhatsapp: false,
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const update = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
    if (error) setError('');
  };

  const save = async (event) => {
    event.preventDefault();
    const phone = form.phone.replace(/\D/g, '').slice(-10);
    if (phone.length !== 10) {
      setError('Enter a valid 10-digit phone number.');
      return;
    }

    setSaving(true);
    setError('');
    try {
      await addCrmLeadContact(leadId, {
        ...form,
        name: form.name.trim(),
        designation: form.designation.trim(),
        phone,
      });
      if (onSaved) onSaved();
      onClose();
    } catch (err) {
      setError(err.message || 'Could not add the contact.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={saving ? undefined : onClose}>
      <div className="modal-content" onClick={(event) => event.stopPropagation()}>
        <form onSubmit={save}>
          <div className="modal-header">
            <h3>Add contact</h3>
            <button type="button" className="modal-close" onClick={onClose} disabled={saving}>×</button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label className="form-label" htmlFor="crm-contact-name">Name</label>
              <input
                id="crm-contact-name"
                type="text"
                className="form-control"
                value={form.name}
                onChange={(event) => update('name', event.target.value)}
                disabled={saving}
                autoFocus
              />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="crm-contact-phone">Phone (10 digits)</label>
              <input
                id="crm-contact-phone"
                type="tel"
                className="form-control"
                value={form.phone}
                onChange={(event) => update('phone', event.target.value)}
                placeholder="9876543210"
                inputMode="numeric"
                required
                disabled={saving}
              />
            </div>
            <div className="form-group">
              <label className="form-label" htmlFor="crm-contact-designation">Designation</label>
              <input
                id="crm-contact-designation"
                type="text"
                className="form-control"
                value={form.designation}
                onChange={(event) => update('designation', event.target.value)}
                disabled={saving}
              />
            </div>
            <div className="crm-contact-options">
              <label>
                <input
                  type="checkbox"
                  checked={form.isPrimary}
                  onChange={(event) => update('isPrimary', event.target.checked)}
                  disabled={saving}
                />
                Primary contact
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={form.doNotCall}
                  onChange={(event) => update('doNotCall', event.target.checked)}
                  disabled={saving}
                />
                Do not call
              </label>
              <label>
                <input
                  type="checkbox"
                  checked={form.noWhatsapp}
                  onChange={(event) => update('noWhatsapp', event.target.checked)}
                  disabled={saving}
                />
                No WhatsApp
              </label>
            </div>
            {error && <div className="crm-form-error">{error}</div>}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={saving || !form.phone.trim()}>
              {saving ? 'Saving…' : 'Add contact'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CrmAddContactDialog;
